import { IconButton, Stack, Tooltip, Typography, Link } from '@mui/material';
import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import copyToClipboard from '../../../utils/copyToClipboard';

const CopyTypography = ({
  text,
  label,
  type = 'text'
}: {
  label: string;
  text: string;
  // eslint-disable-next-line react/require-default-props
  type?: string;
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await copyToClipboard(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Typography variant='body1' sx={{ userSelect: 'all' }}>
        <Typography component='span' fontWeight={600}>
          {label}:{' '}
        </Typography>
        {text}
      </Typography>

      {type === 'text' && (
        <Tooltip title={copied ? 'Copied!' : 'Copy'}>
          <IconButton onClick={handleCopy} size='small' sx={{ ml: 'auto !important' }}>
            <ContentCopyIcon fontSize='small' />
          </IconButton>
        </Tooltip>
      )}
      {type === 'link' && text.includes('http') && (
        <Link href={text} target='_blank' rel='noopener noreferrer' sx={{ ml: 'auto !important' }}>
          <IconButton size='small'>
            <OpenInNewIcon fontSize='small' />
          </IconButton>
        </Link>
      )}
    </Stack>
  );
};

export default React.memo(CopyTypography);
